import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import ThreadSidebar from './Sidebar/ThreadSidebar';
import DropdownPortal from './DropdownPortal'; // or adjust path if needed
import { useRef, useEffect } from 'react';


const sidebarStyle = {
  width: '240px',
  backgroundColor: '#141414',
  color: '#fff',
  height: '100vh',
  padding: '30px 20px',
  paddingTop: '80px', // ⬅️ NEW LINE
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  top: 0,
  left: 0,
  boxShadow: '2px 0 6px rgba(0,0,0,0.08)',
  borderTopRightRadius: '20px',
};

const logoStyle = {
  fontSize: '22px',
  fontWeight: '800',
  marginBottom: '40px',
  color: '#FFD700',
};

const navItemStyle = (isActive, isHovered) => ({
  color: isActive ? '#FFD700' : isHovered ? '#ffffff' : '#e5e7eb',
  backgroundColor: isActive || isHovered ? '#2a2a2a' : 'transparent',
  padding: '10px 16px',
  borderRadius: '8px',
  marginBottom: '16px',
  fontSize: '15px',
  fontWeight: '600',
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'all 0.2s ease-in-out',
});

const topbarStyle = {
  height: '64px',
  backgroundColor: '#ffffff',
  borderBottom: '1px solid #e5e7eb',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between', // <-- makes room for logo & account
  padding: '0 24px',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  zIndex: 10,
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
};

const contentWrapperStyle = {
  marginLeft: '240px',       // Leave room for sidebar
  paddingTop: '64px',        // Leave room for topbar
  paddingBottom: '40px',
  paddingLeft: '40px',
  paddingRight: '0px',
  backgroundColor: '#f9fafb',
  minHeight: '100vh',
  // boxShadow: '0 0 0 1px rgba(0,0,0,0.03)', remove this line
  borderRadius: '20px',
};

const dropdownItem = {
  padding: '12px 16px',
  fontSize: '14px',
  color: '#333',
  backgroundColor: '#fff',
  cursor: 'pointer',
  textAlign: 'left',
  transition: 'background-color 0.2s ease',
};

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const threadIdMatch = location.pathname.match(/^\/thread\/(.+)/);
  const activeThreadId = threadIdMatch ? threadIdMatch[1] : null;
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  const menuItems = [
    { label: 'Industry Research', path: '/industry' },
    { label: 'Prospecting Campaigns', path: '/build-campaign' },
    { label: 'Meeting Preparation', path: '/prep' },
    { label: 'Meeting Follow-Up', path: '/post-call' },
  ];

  return (
    <div style={{ display: 'flex' }}>
      <aside style={sidebarStyle}>
        {menuItems.map(({ label, path }) => {
          const isActive = location.pathname === path;
          const isHovered = hovered === path;

          return (
            <div
              key={label}
              style={navItemStyle(isActive, isHovered)}
              onClick={() => navigate(path)}
              onMouseEnter={() => setHovered(path)}
              onMouseLeave={() => setHovered(null)}
            >
              {label}
            </div>
          );
        })}
      </aside>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <header style={topbarStyle}>
          <div
            style={{
              ...logoStyle,
              fontSize: '38px',
              cursor: 'pointer',
              marginRight: 'auto',
              color: '#FFD700',
              paddingTop: '36px',
              paddingLeft: '10px',
            }}
            onClick={() => navigate('/')}
          >
            Alfred
          </div>

          <div style={{ position: 'relative', paddingRight: '80px' }}>
            <div
              onClick={() => setShowDropdown((prev) => !prev)}
              style={{
                fontWeight: '500',
                fontSize: '16px',
                color: '#333',
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              Account ▾
            </div>

            {showDropdown && (
              <DropdownPortal>
                <div
                  ref={dropdownRef} // 👈 ADD THIS LINE
                  style={{
                    position: 'fixed',
                    top: '72px', // appears just below topbar
                    right: '40px',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    zIndex: 3000,
                    minWidth: '160px'
                  }}>
                  <div
                    style={dropdownItem}
                    onClick={() => {
                      setShowDropdown(false);
                      navigate('/profile');
                    }}
                  >
                    View Profile
                  </div>
                  {localStorage.getItem('isAdmin') === 'true' && (
                    <div
                      style={dropdownItem}
                      onClick={() => {
                        setShowDropdown(false);
                        navigate('/admin/users');
                      }}
                    >
                      Admin Panel
                    </div>
                  )}
                  <div
                    style={{ ...dropdownItem, borderTop: '1px solid #eee' }}
                    onClick={() => {
                      localStorage.removeItem('isAdmin');
                      window.location.href = '/';
                    }}
                  >
                    Logout
                  </div>
                </div>
              </DropdownPortal>
            )}
          </div>
        </header>

        <main style={{
          ...contentWrapperStyle,
          marginRight: window.innerWidth < 768 ? '0px' : isSidebarCollapsed ? '48px' : '320px'
        }}>
          <Outlet />
        </main>
      </div>

      <ThreadSidebar activeThreadId={activeThreadId} />
    </div>
  );
};

export default MainLayout;
